import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/health-care-service";
const API_PATH_EXCEL = ConstantList.API_EN_POINT + "/excel";
const API_PATH_IMPORT_EXPORT_EXCEL = ConstantList.API_EN_POINT + "/emr/import-export-file";

export const pagingHealthCareService = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getHealthCareServiceById = (healthCareServiceId) =>
  axios.get(API_PATH + "/getbyid/" + healthCareServiceId);

export const findByCodeHealthCareService = (code) =>
  axios.get(API_PATH + "/find-by-code/" + code);

export const saveHealthCareService = (healthCareService) =>
  axios.post(API_PATH + "/save-or-update", healthCareService);

export const saveHealthCareServiceIsUsing = (healthCareServiceIsUsing) =>
  axios.post(API_PATH + "/update-is-using", healthCareServiceIsUsing);

export const deleteHealthCareService = (healthCareServiceId) =>
  axios.delete(API_PATH + "/mark-delete/" + healthCareServiceId);
export const getAllHealthCareService = () => axios.get(API_PATH + "/getAll");
export const getAllHealthCareServiceByConceptIdAndExamination = (conceptId, applicableObjectValue, age, serviceTypeCode) =>
  axios.post(API_PATH + "/get-list-service", {
    conceptId: conceptId,
    applicableObject: applicableObjectValue,
    age: age,
    serviceTypeCode: "examination",
  });
export const getListServiceRoom = (conceptId, patientTypeServiceId, age, serviceId, roomId) =>
  axios.post(API_PATH + "/get-list-service-room", {
    conceptId: conceptId,
    patientTypeServiceId: patientTypeServiceId,
    age: age,
    serviceTypeCode: "examination",
    serviceId: serviceId,
    roomId: roomId,
    // listServiceTypeCode: [
    //   "examination", "other_service"
    // ]
  });

//dich vu theo phong va nguoc lai
export const getServiceRoomPage = (searchObject) => axios.post(API_PATH + "/search-service-room-page", searchObject);

export const downloadTemplate = () => {
  let url = API_PATH_EXCEL + "/download-template-health-care-service";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadServiceData = () => {
  const url = API_PATH_IMPORT_EXPORT_EXCEL + "/export-health-care-service";
  return axios.post(
    url,
    {},
    {
      responseType: "blob",
    }
  );
};